export class AuthRoutes {
	public static readonly Logout: string = 'logout';
	public static readonly Landing: string = 'landing';
}
